import { ProfileImage } from '@/Components/Specific';
import { UI } from '@/Components/UI';
import { ProfilePreview } from '@/types';
import { useLocalizedRoute } from '@/hooks';
import { useTranslation } from 'react-i18next';
import { HTMLProps } from 'react';

type AuthorProps = {
    author: ProfilePreview;
} & HTMLProps<HTMLDivElement>

export const Author = ({ author, className }: AuthorProps) => {
    const { t } = useTranslation(['recipes']);
    const { localizedRoute } = useLocalizedRoute();

    return (
        <UI.Card className={className}>
            <div className={'grid grid-cols-[1fr_auto] gap-2 items-center mb-2'}>
                <div>
                    <p className={'text-outline'}>
                        {t('author.title')}
                    </p>

                    <div className={'font-semibold'}>
                        {author.name}
                    </div>
                </div>

                <ProfileImage
                    user={author}
                    className={'text-4xl'} />
            </div>

            <UI.Link href={localizedRoute('profile.show', { profile: author.slug })}>
                {t('misc:seeMore')}
            </UI.Link>
        </UI.Card>
    );
};
